module.exports = __webpack_public_path__ + "img/instrucoes-como-nao-fazer-selfie.518a2ba9.png";